export default "__VITE_ASSET__CSQhocGa__"